export default class ReportListCtrl {
	constructor($rootScope, $scope, $timeout, $mdDialog, $cookies, reportSrv, $stateParams, WorkPlanIndicatorSrv, GlobalConfig, Requests, $window) {
		var reportListVm = this
		const currentUser = JSON.parse($cookies.get('currentUser'))
		const roleId = $cookies.get('hasRoleId');

		// VARIABLES
		reportListVm.viewLoaded = false
		reportListVm.active = GlobalConfig.generals.active
		reportListVm.notActive = GlobalConfig.generals.notActive
		reportListVm.filterSearchResult = GlobalConfig.appTexts.filterResult.unSatisfactory
		reportListVm.planningFinish = true
		reportListVm.showModalToEnterTitle = showModalToEnterTitle
		reportListVm.exportToExcel = exportToExcel
		reportListVm.generate = generate
		reportListVm.exportToExcelSaveTitle = exportToExcelSaveTitle
		reportListVm.showdata1 = showdata1
		reportListVm.isDinamic = $stateParams.globalView
		// reportListVm.finalize=finalize;
		$scope.classPlanning = ''
		$scope.reportDisable = true
		$scope.reportGuardar = true
		$scope.reportAbrir = true
		$scope.GlobalView = $stateParams.globalView
		$scope.data = {};
		$scope.param = {};

		let post = {
			workplanId: currentUser.workplanId,
			teacherId: currentUser.teacherId,
			userId: currentUser.id,
			rolId: roleId,
		}

		console.log('current user', currentUser)

		$rootScope.$on('rootScope:ReportEmit', function (event, data) {
			// alert(data); // 'Emit!'
			activate()
		});

		activate()

		// METHODS
		reportListVm.roles = []



		function activate() {

			var parma = {
				workplanId: currentUser.workplanId,
				teacherId: currentUser.teacherId,
				userId: currentUser.id,
				rolId: roleId,
			}

			getReportDynamicData(parma);
		}

		function showmode() {
			//Funcion de ejemplo del pluggin
			$.getJSON("https://pivottable.js.org/examples/mps.json", function (mps) {
				$("#output2").pivotUI(mps, {
					onRefresh: function (config) {
						var config_copy = JSON.parse(JSON.stringify(config));

						//delete some values which are functions
						delete config_copy["aggregators"];
						delete config_copy["renderers"];
						//delete some bulky default values
						delete config_copy["rendererOptions"];
						delete config_copy["localeStrings"];

						$("#output").text(JSON.stringify(config_copy, undefined, 2));
					}
				});
			});
		}

		function showdata(data) {
			$scope.data = data;
			$scope.reportDisable = false
			$scope.reportGuardar = false
            //****************************** LO ANTIGUO *********************************** */
			// $("#rosario_report_wrapper").html('')
			// $("#rosario_report_wrapper").append('<textarea id="output" style="float: left; width: 250px; height: 500px; margin: 10px; display: none;" readonly></textarea><div id="output2" style="margin: 30px;"></div>')
 
			$("#output").html('')
			$("#output").append('<textarea id="output" style="float: left; width: 250px; height: 500px; margin: 10px; display: none;" readonly></textarea><div id="output2" style="margin: 30px;"></div>')

			// $("#rosario_report_wrapper #output2").pivotUI(data, {
			// 	onRefresh: function (config) {
			// 		var config_copy = JSON.parse(JSON.stringify(config));
			// 		//delete some values which are functions
			// 		delete config_copy["aggregators"];
			// 		delete config_copy["renderers"];
			// 		//delete some bulky default values
			// 		// delete config_copy["rendererOptions"];
			// 		$("#rosario_report_wrapper #output").text(JSON.stringify(config_copy, undefined, 2));
			// 	},
			// 	localeStrings: { totals: "Total" },
			// 	rendererOptions: { localeStrings: { totals: "Total" } },
			// 	renderers: {
			// 		"Tabla": $.pivotUtilities.renderers["Table"],
			// 		"Tabla Barras": $.pivotUtilities.renderers["Table Barchart"],
			// 		"Mapa Calor": $.pivotUtilities.renderers["Heatmap"],
			// 		"Mapa Calor Fila": $.pivotUtilities.renderers["Row Heatmap"],
			// 		"Mapa Calor Columna": $.pivotUtilities.renderers["Col Heatmap"],
			// 		"Mapa Árbol": $.pivotUtilities.d3_renderers["Treemap"],
			// 		"Graf Barra Horizontal": $.pivotUtilities.c3_renderers["Horizontal Bar Chart"],
			// 		"Graf Barra Apilado Horizontal": $.pivotUtilities.c3_renderers["Horizontal Stacked Bar Chart"],
			// 		"Graf Barra": $.pivotUtilities.c3_renderers["Bar Chart"],
			// 		"Graf Barra Apilado": $.pivotUtilities.c3_renderers["Stacked Bar Chart"],
			// 		"Graf Linea": $.pivotUtilities.c3_renderers["Line Chart"],
			// 		"Graf Area": $.pivotUtilities.c3_renderers["Area Chart"],
			// 		"Graf Dispersión": $.pivotUtilities.c3_renderers["Scatter Chart"],
			// 		"Exportar a TSV": $.pivotUtilities.export_renderers["TSV Export"]
			// 	},
			// 	aggregators: {
			// 		"Contar": $.pivotUtilities.aggregators["Count"],
			// 		"Contar Valores Unicos": $.pivotUtilities.aggregators["Count Unique Values"],
			// 		"Listar Valores Unicos": $.pivotUtilities.aggregators["List Unique Values"],
			// 		"Sumar": $.pivotUtilities.aggregators["Sum"],
			// 		"Sumar Enteros": $.pivotUtilities.aggregators["Integer Sum"],
			// 		"Promedio": $.pivotUtilities.aggregators["Average"],
			// 		"Mediana": $.pivotUtilities.aggregators["Median"],
			// 		"Muestra Variación": $.pivotUtilities.aggregators["Sample Variance"],
			// 		"Muestra Desviación Estandar": $.pivotUtilities.aggregators["Sample Standart Deviation"],
			// 		"Minimo": $.pivotUtilities.aggregators["Minimum"],
			// 		"Maximo": $.pivotUtilities.aggregators["Maximum"],
			// 		"Primero": $.pivotUtilities.aggregators["First"],
			// 		"Ultimo": $.pivotUtilities.aggregators["Last"],
			// 		"Suma sobre Suma": $.pivotUtilities.aggregators["Sum over Sum"],
			// 		"80% Limite Superior": $.pivotUtilities.aggregators["80% Upper Bound"],
			// 		"80% Limite Inferior": $.pivotUtilities.aggregators["80% Lower Bound"],
			// 		"Suma Fraccion del Total": $.pivotUtilities.aggregators["Sum as Fraction of Total"],
			// 		"Suma Fraccion de Filas": $.pivotUtilities.aggregators["Sum as Fraction of Rows"],
			// 		"Suma Fraccion de Columnas": $.pivotUtilities.aggregators["Sum as Fraction of Columns"],
			// 		"Contar Fraccion del Total": $.pivotUtilities.aggregators["Count as Fraction of Total"],
			// 		"Contar Fraccion de Filas": $.pivotUtilities.aggregators["Count as Fraction of Rows"],
			// 		"Contar Fraccion de Columnas": $.pivotUtilities.aggregators["Count as Fraction of Columns"]
			// 	}
			// });
			//************************************LO NUEVO ****************************************** */
			$("#output #output2").pivotUI( data,{
				onRefresh: function (config) {
					var config_copy = JSON.parse(JSON.stringify(config));
					//delete some values which are functions
					delete config_copy["aggregators"];
					delete config_copy["renderers"];
					//delete some bulky default values
					// delete config_copy["rendererOptions"];
					$("#rosario_report_wrapper #output").text(JSON.stringify(config_copy, undefined, 2));
				},
				localeStrings: { totals: "Total" },
				rendererOptions: { localeStrings: { totals: "Total" } } ,
				renderers: {
					"Tabla": $.pivotUtilities.renderers["Table"],
					"Tabla Barras": $.pivotUtilities.renderers["Table Barchart"],
					"Mapa Calor": $.pivotUtilities.renderers["Heatmap"],
					"Mapa Calor Fila": $.pivotUtilities.renderers["Row Heatmap"],
					"Mapa Calor Columna": $.pivotUtilities.renderers["Col Heatmap"],
					"Mapa Árbol": $.pivotUtilities.d3_renderers["Treemap"],
					"Graf Barra Horizontal": $.pivotUtilities.c3_renderers["Horizontal Bar Chart"],
					"Graf Barra Apilado Horizontal": $.pivotUtilities.c3_renderers["Horizontal Stacked Bar Chart"],
					"Graf Barra": $.pivotUtilities.c3_renderers["Bar Chart"],
					"Graf Barra Apilado": $.pivotUtilities.c3_renderers["Stacked Bar Chart"],
					"Graf Linea": $.pivotUtilities.c3_renderers["Line Chart"],
					"Graf Area": $.pivotUtilities.c3_renderers["Area Chart"],
					"Graf Dispersión": $.pivotUtilities.c3_renderers["Scatter Chart"],
					"Exportar a TSV": $.pivotUtilities.export_renderers["TSV Export"]
				},
				aggregators: {
					"Contar": $.pivotUtilities.aggregators["Count"],
					"Contar Valores Unicos": $.pivotUtilities.aggregators["Count Unique Values"],
					"Listar Valores Unicos": $.pivotUtilities.aggregators["List Unique Values"],
					"Sumar": $.pivotUtilities.aggregators["Sum"],
					"Sumar Enteros": $.pivotUtilities.aggregators["Integer Sum"],
					"Promedio": $.pivotUtilities.aggregators["Average"],
					"Mediana": $.pivotUtilities.aggregators["Median"],
					"Muestra Variación": $.pivotUtilities.aggregators["Sample Variance"],
					"Muestra Desviación Estandar": $.pivotUtilities.aggregators["Sample Standart Deviation"],
					"Minimo": $.pivotUtilities.aggregators["Minimum"],
					"Maximo": $.pivotUtilities.aggregators["Maximum"],
					"Primero": $.pivotUtilities.aggregators["First"],
					"Ultimo": $.pivotUtilities.aggregators["Last"],
					"Suma sobre Suma": $.pivotUtilities.aggregators["Sum over Sum"],
					"80% Limite Superior": $.pivotUtilities.aggregators["80% Upper Bound"],
					"80% Limite Inferior": $.pivotUtilities.aggregators["80% Lower Bound"],
					"Suma Fraccion del Total": $.pivotUtilities.aggregators["Sum as Fraction of Total"],
					"Suma Fraccion de Filas": $.pivotUtilities.aggregators["Sum as Fraction of Rows"],
					"Suma Fraccion de Columnas": $.pivotUtilities.aggregators["Sum as Fraction of Columns"],
					"Contar Fraccion del Total": $.pivotUtilities.aggregators["Count as Fraction of Total"],
					"Contar Fraccion de Filas": $.pivotUtilities.aggregators["Count as Fraction of Rows"],
					"Contar Fraccion de Columnas": $.pivotUtilities.aggregators["Count as Fraction of Columns"]
				}
			});
		}

		function getReportDynamicData(post) {
			return reportSrv.getReportDynamic.post(post).$promise.then((dataResult) => {
				if (dataResult.status) {
					showdata(dataResult.reportData)
				} else {
					console.log("Error")
				}
			}).catch((error) => { console.error(error) })
		}

		function showModalToEnterTitle() {
			var THIS = this;
			var SCOPE = $scope;
			var temp1 = [], temp2 = [];
			SCOPE.param = {};

			var config = $("#output2").data("pivotUIOptions")

			$('.pvtUi tr td.pvtCols li').each(function () {
				var str = this.innerText;
				str = str.substring(0, str.length - 1);
				temp1.push($.trim(str))
			});

			$('.pvtUi tr td.pvtRows li').each(function () {
				var str = this.innerText;
				str = str.substring(0, str.length - 1);
				temp2.push($.trim(str))
			});

			if (temp1.lenght > 0 || temp2.length > 0) {
				$mdDialog.show({
					controller: ['$scope', '$mdDialog', '$window', 'reportSrv', '$cookies', function ($scope, $mdDialog) {
						$scope.saveReport = function () {
							$scope.inactive = true;

							if (typeof $scope.reportName === 'undefined') {
								console.log("Error")
							} else {
								return reportSrv.ValidNameReport.post({ title: $scope.reportName }).$promise.then((result) => {
									if (result.data[0].cant_name == 0) {
										var config_copy = JSON.parse(JSON.stringify(config));
										//delete some values which will not serialize to JSON
										delete config_copy["aggregators"]
										delete config_copy["renderers"]

										var roleid = $cookies.get('hasRoleId')
										var user = $cookies.get('currentUser')
										var userId = JSON.parse(user)

										SCOPE.param = {
											title: $scope.reportName,
											config: JSON.stringify(config_copy),
											idRole: roleid,
											idUser: userId.id
										}

										$mdDialog.hide()
										return reportSrv.SaveReportData.post(SCOPE.param).$promise.then((dataResult) => {
											if (dataResult.status) {
												THIS.exportToExcelSaveTitle();
												THIS.exportToExcel($scope.reportName);
												$scope.reportName = '';
											} else {
												console.log("Error")
											}
										}).catch((error) => { console.error(error) })
									} else {
										$mdDialog.show({
											controller: ['$scope', '$mdDialog', '$window', 'reportSrv', '$cookies', function ($scope, $mdDialog) {
												$scope.finalize = function () {
													$mdDialog.hide()
												}
											}],
											template: require('./modalMsjNameReport.html'),
											clickOutsideToClose: false
										})
									}

								})
							}
						}

						$scope.close = function () {
							$mdDialog.hide()
						}
					}],
					template: require('./modalToEnterTitle.html'),
					clickOutsideToClose: false
				})
			}


		}

		function exportToExcelSaveTitle() {

			var THIS = this;
			var SCOPE = $scope
			$mdDialog.show({
				controller: ['$scope', '$mdDialog', '$window', 'reportSrv', '$cookies', function ($scope, $mdDialog) {
					$scope.finalize = function () {
						$mdDialog.hide()
					}

					$scope.close = function () {
						$mdDialog.hide()
					}
				}],
				template: require('./modalSaveFinalizeReport.html'),
				clickOutsideToClose: false
			})
		}

		function exportToExcel() {
			$scope.loadingLoop = true;
			TableToExcel.convert(
				$window.document.querySelector(".pvtTable"),
				{
					name: `reporte-dinamico-${moment().format('DD/MM/YYYY')}.xlsx`,
					autoStyle: true,
					sheet: {
						name: "hoja 1"
					}
				}
			);
			$timeout(() => $scope.loadingLoop = false, 3000);
		}

		function generate(data) {
			var THIS = this;
			var SCOPE = $scope;
			console.log($scope.data)
			var data = JSON.stringify($scope.data, undefined, 2)
			$mdDialog.show({
				controller: ['$scope', '$mdDialog', '$window', '$cookies', function ($scope, $mdDialog) {


					var roleid = $cookies.get('hasRoleId')
					var user = $cookies.get('currentUser')
					var userId = JSON.parse(user)
					var isDinamic = reportListVm.isDinamic

					$scope.selectValue = {}

					var param = { idRole: roleid, idUser: userId.id, isDinamic: isDinamic }

					reportSrv.getReportData.get(param).$promise.then((dataResult) => {

						if (dataResult.status) {

							$scope.selectValue = dataResult.reportData;
							// $mdDialog.hide()

						} else {
							console.log("Error")
						}
					}).catch((error) => { console.error(error) })

					$scope.getSelectedReport = function (reportData) {
						if (typeof $scope.reportData !== 'undefined') {
							SCOPE.reportAbrir = false;
							console.log($scope.reportData)
							return $scope.reportData.title
						} else {
							SCOPE.reportAbrir = true;
							return "Seleccione un Reporte";
						}

					}

					$scope.abrir = function () {
						if (typeof $scope.reportData !== 'undefined') {
							var jsonData = $scope.reportData;
							// jsonData
							var colRows = JSON.parse(jsonData.jsonData)
							THIS.showdata1(SCOPE.data, colRows);
							$mdDialog.hide()

						}

					}

					$scope.close = function () {
						$mdDialog.hide()
					}


				}],
				template: require('./modalToSelectTheReport.html'),
				clickOutsideToClose: false
			})

		}

		function showdata1(data, colRows) {

			$('#rosario_report_wrapper').html('');

			colRows.localeStrings.totals = "Total";
			colRows.rendererOptions.localeStrings.totals = "Total";
			colRows.renderers = {
				"Tabla": $.pivotUtilities.renderers["Table"],
				"Tabla Barras": $.pivotUtilities.renderers["Table Barchart"],
				"Mapa Calor": $.pivotUtilities.renderers["Heatmap"],
				"Mapa Calor Fila": $.pivotUtilities.renderers["Row Heatmap"],
				"Mapa Calor Columna": $.pivotUtilities.renderers["Col Heatmap"],
				"Mapa Árbol": $.pivotUtilities.d3_renderers["Treemap"],
				"Graf Barra Horizontal": $.pivotUtilities.c3_renderers["Horizontal Bar Chart"],
				"Graf Barra Apilado Horizontal": $.pivotUtilities.c3_renderers["Horizontal Stacked Bar Chart"],
				"Graf Barra": $.pivotUtilities.c3_renderers["Bar Chart"],
				"Graf Barra Apilado": $.pivotUtilities.c3_renderers["Stacked Bar Chart"],
				"Graf Linea": $.pivotUtilities.c3_renderers["Line Chart"],
				"Graf Area": $.pivotUtilities.c3_renderers["Area Chart"],
				"Graf Dispersión": $.pivotUtilities.c3_renderers["Scatter Chart"],
				"Exportar a TSV": $.pivotUtilities.export_renderers["TSV Export"]
			};

			colRows.aggregators = {
				"Contar": $.pivotUtilities.aggregators["Count"],
				"Contar Valores Unicos": $.pivotUtilities.aggregators["Count Unique Values"],
				"Listar Valores Unicos": $.pivotUtilities.aggregators["List Unique Values"],
				"Sumar": $.pivotUtilities.aggregators["Sum"],
				"Sumar Enteros": $.pivotUtilities.aggregators["Integer Sum"],
				"Promedio": $.pivotUtilities.aggregators["Average"],
				"Mediana": $.pivotUtilities.aggregators["Median"],
				"Muestra Variación": $.pivotUtilities.aggregators["Sample Variance"],
				"Muestra Desviación Estandar": $.pivotUtilities.aggregators["Sample Standart Deviation"],
				"Minimo": $.pivotUtilities.aggregators["Minimum"],
				"Maximo": $.pivotUtilities.aggregators["Maximum"],
				"Primero": $.pivotUtilities.aggregators["First"],
				"Ultimo": $.pivotUtilities.aggregators["Last"],
				"Suma sobre Suma": $.pivotUtilities.aggregators["Sum over Sum"],
				"80% Limite Superior": $.pivotUtilities.aggregators["80% Upper Bound"],
				"80% Limite Inferior": $.pivotUtilities.aggregators["80% Lower Bound"],
				"Suma Fraccion del Total": $.pivotUtilities.aggregators["Sum as Fraction of Total"],
				"Suma Fraccion de Filas": $.pivotUtilities.aggregators["Sum as Fraction of Rows"],
				"Suma Fraccion de Columnas": $.pivotUtilities.aggregators["Sum as Fraction of Columns"],
				"Contar Fraccion del Total": $.pivotUtilities.aggregators["Count as Fraction of Total"],
				"Contar Fraccion de Filas": $.pivotUtilities.aggregators["Count as Fraction of Rows"],
				"Contar Fraccion de Columnas": $.pivotUtilities.aggregators["Count as Fraction of Columns"]
			};

			$("#rosario_report_wrapper").append('<textarea id="output" style="float: left; width: 250px; height: 500px; margin: 10px; display: none;" readonly></textarea><div id="output2" style="margin: 30px;"></div>')
			$("#rosario_report_wrapper #output2").pivotUI(data, colRows, true)

		}

	}
}

ReportListCtrl.$inject = ['$rootScope', '$scope', '$timeout', '$mdDialog', '$cookies', 'reportSrv', '$stateParams', 'WorkPlanIndicatorSrv', 'GlobalConfig', 'Requests', '$window']



// WEBPACK FOOTER //
// ./src/app/u-faculty/report/list/reportListCtrl.js